import { useCallback } from 'react'
import { matchPath } from 'react-router'
import { useHistory } from 'react-router-dom'

const getPageTitle = (pathname: string) => {
  if (matchPath(pathname, `/activity/contacts/:id`)) {
    return 'Contact activity'
  } else if (matchPath(pathname, `/activity/accounts/:id`)) {
    return 'Account activity'
  } else if (matchPath(pathname, `/activity`)) {
    return 'Account activity'
  }
}

const useBreadcrumb = () => {
  const history = useHistory()
  const title = getPageTitle(history.location.pathname)
  const navigateTo = useCallback(
    (pathname: string, state?: Record<string, any>) => {
      history.push({
        pathname,
        state: {
          navigatedFrom: title,
          navigatedFromUrl: history.location.pathname,
          ...state
        }
      })
    },
    [history, title]
  )

  return { navigateTo, title }
}

export default useBreadcrumb
